import { AdvertisingApi } from './api/advertising';
import { plainToClassFromExist } from 'class-transformer';
import { ResponsesModel } from '@/models/classes/responses';
import { AdvertisingTypeModel, AdvertisingItemModel } from '@/models/classes/advertising';

const api = new AdvertisingApi();


export class AdvertisingService {
    fetchTypes = async () => {
        const resData = await api.getAdvertisingTypes();
        const resModel = plainToClassFromExist(new ResponsesModel<AdvertisingTypeModel>(AdvertisingTypeModel), resData);
        if (resModel.status == 200 && typeof resModel.data == "object") {
            return resModel.data;
        }
        return [];
    };

    fetchList = async (advertising: number, limit: number, offset: number) => {
        const resData = await api.getAdvertisingList(advertising, limit, offset);
        const resModel = plainToClassFromExist(new ResponsesModel<AdvertisingItemModel>(AdvertisingItemModel), resData);

        if (resModel.status == 200 && typeof resModel.data == "object") {
            return { data: resModel.data, total: resModel.total ?? 0 };
        }
        return null;
    };
}
